type SupabaseErrorLike = {
    message?: string | null;
    details?: string | null;
};

/**
 * Supabase-js converts thrown errors (e.g. RequestCancelledError from the
 * custom fetch wrapper) into a PostgrestError-shaped object with the original
 * message in `details`/`message`. These are navigation cancels, not failures.
 */
export function isSupabaseRequestCancelled(error: SupabaseErrorLike): boolean {
    const blob = `${error.message ?? ''}${error.details ?? ''}`;
    return blob.includes('RequestCancelledError') || blob.includes('navigation or unmount');
}
